import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate } from '@angular/router';
import { UserService } from 'src/modules/user.service';
import { RequestAccessFormComponent } from './request-access-form/request-access-form.component';
import { CgpAlertDialogService } from 'src/app/shared/cgp-alert-dialog/cgp-alert-dialog.service';

@Injectable({
   providedIn: 'root'
})
export class TprecmRoutingGuard implements CanDeactivate<RequestAccessFormComponent> {
   constructor(
      private readonly userService: UserService,
      private readonly cgpAlertDialogService: CgpAlertDialogService
   ) {

   }
   canDeactivate(
      component: RequestAccessFormComponent,
      currentRoute: ActivatedRouteSnapshot,
      currentState: RouterStateSnapshot,
      nextState: RouterStateSnapshot
   ) {
      if (!this.userService.UserProfile) {
         this.cgpAlertDialogService.showAlertDialog({
            title: 'Unauthorized',
            message: 'Please submit a request to access TPRECM',
            alert: 'danger',
            closeLabel: 'OK'
         });
         return false;
      }
      return true;
   }
}
